import React, { useCallback, useState } from 'react';
import { Accordion } from 'rsuite';
import { CalculatedLicense, CalculatedPeriodLicense } from 'src/types/tax';
import { ActivityDetails } from '../TaxConfirm/ActivityDetails/ActivityDetails';

export interface TaxConfirmPeriodAccordionProps {
  period: CalculatedLicense;
}

/** Renders an Accordion for one period's licenses with memoized onSelect. */
export const TaxConfirmPeriodAccordion = React.memo(
  ({ period }: TaxConfirmPeriodAccordionProps) => {
    const [activeKey, setActiveKey] = useState<string>();
    const onAccordionSelect = useCallback(
      (eventKey: string | number | undefined) => {
        const key = eventKey !== undefined ? String(eventKey) : undefined;
        setActiveKey((oldKey) => (oldKey === key ? undefined : key));
      },
      []
    );

    const handleCloseModal = useCallback(() => {
      setActiveKey(undefined);
    }, []);

    return (
      <Accordion
        onSelect={onAccordionSelect}
        className="no-border-accordion"
      >
        {period.licenses?.map(
          (license: CalculatedPeriodLicense, index: number) => {
            const panelKey = `${period.startDate}_${license.licenseNumber ?? index}`;
            const expanded = panelKey === activeKey;

            return (
              <ActivityDetails
                key={panelKey}
                panelKey={panelKey}
                period={period}
                license={license}
                show={expanded}
                onClose={handleCloseModal}
              />
            );
          }
        )}
      </Accordion>
    );
  }
);

TaxConfirmPeriodAccordion.displayName = 'TaxConfirmPeriodAccordion';
